import type { ReactNode } from "react";
import { AlertCircle, CheckCircle2, Info } from "lucide-react";
import { cn } from "@/lib/utils";

export type NoticeTone = "neutral" | "success" | "warning" | "danger";

const TONE_CLASSES: Record<NoticeTone, string> = {
  neutral: "border-border bg-[hsl(var(--surface)/0.75)] text-muted-foreground",
  success: "border-primary/25 bg-primary/10 text-primary",
  warning: "border-[hsl(var(--gold)/0.25)] bg-[hsl(var(--gold)/0.10)] text-[hsl(var(--gold))]",
  danger: "border-destructive/30 bg-destructive/10 text-destructive",
};

/** Aviso inline das telas de links (mesmo visual do restante do painel). */
export function Notice({ tone, children }: { tone: NoticeTone; children: ReactNode }): JSX.Element {
  const Icon = tone === "success" ? CheckCircle2 : tone === "neutral" ? Info : AlertCircle;
  return (
    <div
      role={tone === "danger" ? "alert" : "status"}
      className={cn("flex items-start gap-3 rounded-lg border px-4 py-3 text-sm", TONE_CLASSES[tone])}
    >
      <Icon size={16} className="mt-0.5 shrink-0" />
      <div className="min-w-0 space-y-1">{children}</div>
    </div>
  );
}
